import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import Controls from '../../components/controls/Controls';
import { useForm, Form } from '../../components/useForm';

const initialFValues = {
  idRessource: '',
  title: '',
};

export default function ResourcesForm({ addOrEdit, recordForEdit }) {
  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ('idRessource' in fieldValues)
      temp.idRessource = fieldValues.idRessource ? '' : 'Ce champ est obligatoire';

    if ('title' in fieldValues)
      temp.title = fieldValues.title ? '' : 'Ce champ est obligatoire';

    setErrors({
      ...temp,
    });

    if (fieldValues === values) return Object.values(temp).every((val) => val === '');
  };

  const { values, setValues, setErrors, errors, handleInputChange, resetForm } = useForm(
    initialFValues,
    true,
    validate,
  );

  useEffect(() => {
    if (recordForEdit != null) {
      setValues({
        ...recordForEdit,
      });
    }
  }, [recordForEdit, setValues]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) await addOrEdit(values, resetForm);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={12}>
          <Controls.Input
            name='idRessource'
            label='Id ressource'
            value={values.idRessource}
            onChange={handleInputChange}
            error={errors.idRessource}
            disabled={recordForEdit ? true : false}
          />
          <Controls.Input
            name='title'
            label='Nom'
            value={values.title}
            onChange={handleInputChange}
            error={errors.title}
          />
          <div style={{ marginTop: 16 }}>
            <Controls.Button
              type='submit'
              text={recordForEdit ? 'Modifier' : 'Ajouter'}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}
